import React from "react";
import AppConfig from "../../../config/AppConfig";
import {AppIconThumbnail} from "../../../components/BaseComponents/AppIconThumbnail";
import {ShopUserSettingsSwitch} from "./ShopUserSettingsSwitch";

export class SettingsAppItem extends React.Component {

    constructor(props) {
        super(props);
    }

    shouldComponentUpdate(nextProps, nextState, nextContext) {
        return nextProps.negozio !== this.props.negozio;
    }

    render() {
        var imageFullUrl = `${AppConfig.webServerUrl}/api/negozio/${this.props.negozio.id_negozio}/logoIcon/100`;
        return (
            <div className={"list-group-item list-group-item-action"} key={this.props.negozio.id_negozio}
                 style={this.props.style}>
                <div className={"d-flex align-items-center"}>
                    <AppIconThumbnail src={imageFullUrl} size={"32px"}/>
                    <h5 className="my-0 ml-2">{this.props.negozio.nome}</h5>
                </div>
                <ShopUserSettingsSwitch negozio={this.props.negozio} settingName={"notifiche"}
                                        title={"Notifiche commerciali"}/>
                <ShopUserSettingsSwitch negozio={this.props.negozio} settingName={"sms"}
                                        title={"SMS commerciali"}/>
                <ShopUserSettingsSwitch negozio={this.props.negozio} settingName={"email"}
                                        title={"Email commerciali"}/>
                <ShopUserSettingsSwitch negozio={this.props.negozio} settingName={"whatsapp"}
                                        title={"Messaggi su Whatsapp"}/>
                <small>Ricevi notifiche riguardo a news, offerte ed eventi che questa attività ha da offrire</small>
                {/*<ShopUserSettingsSwitch negozio={negozio} settingName={"calendario"} title={"Sincronizza calendario"}/>*/}
            </div>
        )
    }

}